import { render, staticRenderFns } from "./EditorHeaderMobileSlideUpMenu.vue?vue&type=template&id=e8f2b3b2&"
import script from "./EditorHeaderMobileSlideUpMenu.vue?vue&type=script&lang=js&"
export * from "./EditorHeaderMobileSlideUpMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports